// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"15330":"be22c9397d39f778","92888":"00e954e346cc97a0"}[chunkId] + ".css";
};